import {ColorFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownColor} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useColorFilterSection} from '../../shared/useColorFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: ColorFilterSection;
  resetFilter: (slug: string) => void;
  setFilter: ({
    filterId,
    filterSection,
  }: {
    filterId: string;
    filterSection: string;
  }) => void;
  onOpen: (filterSlug: string, label: FilterLabels) => void;
  onClose: (filterSlug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionColor: FC<Props> = ({
  activeFilters,
  data,
  resetFilter,
  setFilter,
  onOpen,
  onClose,
  filterLabel,
}) => {
  const {activeSlugFilters, label, normalizedColors, slug} =
    useColorFilterSection({activeFilters, data});

  return (
    <FilterDropdownColor
      activeColorIds={activeSlugFilters}
      colors={normalizedColors}
      key={`filter-flyout-${slug}`}
      label={label}
      onClose={() => onClose(slug, filterLabel)}
      onOpen={() => onOpen(slug, filterLabel)}
      onColorClick={colorId => {
        setFilter({
          filterId: colorId,
          filterSection: slug,
        });
      }}
      onFilterReset={() => resetFilter(slug)}
    />
  );
};
